'use client';

/**
 * Spolocny engine pre celu stranku.
 *
 * Mikrofonove tlacidlo v hero a chat dok su dva samostatne stromy komponentov,
 * ale musia zdielat jeden rozhovor - inak by kazdy spustil vlastny mikrofon
 * a vlastny dialog. Preto kontext.
 *
 * Ked provider chyba (napr. na inej stranke), hook vrati null a komponenty
 * ostanu pri svojom povodnom lokalnom spravani. Nic sa nerozbije.
 */

import { createContext, useContext, type ReactNode } from 'react';
import { useVoxEngine, type VoxEngineSoVlnou } from './useVoxEngine';


const VoxCtx = createContext<VoxEngineSoVlnou | null>(null);

export function VoxProvider({ children }: { children: ReactNode }) {
    const engine = useVoxEngine();
    return <VoxCtx.Provider value={engine}>{children}</VoxCtx.Provider>;
}

/** Engine, alebo null ked komponent nie je vnutri providera. */
export function useVoxCtx(): VoxEngineSoVlnou | null {
    return useContext(VoxCtx);
}
